import {
  GET_ENQUIRY_FORM_QUESTIONS,
  GET_PROJECTS,
  PRIVACY_STATEMENT_PDF,
  SUBMIT_ENQUIRY_FORM,
} from '@/utils/constants/constants.js';

import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';

export default {
  name: 'EnquiryForm',
  mixins: [alert_mixin],
  components: {
    AICampusFooter,
    navbar
  },

  data: () => ({
    selected_project: "",
    projects: [],
    enquiry_form_id: null,
    enquiry_form_questions: [],
    form_data: {},
    submission_success: false,
    privacy_statement: null,
    pdf_url: null
  }),

  computed: {
    current_domain() {
      const hostname = window.location.hostname;

      if (hostname.includes('trustfirst') || hostname.includes('trust-first')) return 'trustfirst';
      if (hostname.includes('x-verdict') || hostname.includes('xverdict')) return 'x-verdict';
      if (hostname.includes('probaworkflows') || hostname.includes('proba-workflows')) return 'probaworkflows';
      if (hostname.includes('ndabenitrust')) return 'ndabenitrust';

      return 'probaworkflows';
    },

    show_terms() {
      const hostname = window.location.hostname;
      return hostname.includes('trustfirst') || hostname.includes('trust-first');
    },

    show_submit_button() {
      return this.enquiry_form_questions.length > 0;
    }
  },

  mounted() {
    this.fetch_projects();
    this.privacy_statement = PRIVACY_STATEMENT_PDF;
    this.create_pdf_url();
  },

 methods: {
    async fetch_projects() {
      const response = await axios.get(GET_PROJECTS);

      if (response.data.status === 'success') {
        this.projects = response.data.data;
      } else {
        this.show_error("Failed to fetch projects.");
      }
    },


    extract_question_title(q) {
      const question = q.question || {};
      const title = question.question_text || question.text || question.label || "Untitled Question";
      return title;
    },

    extract_question_type(q) {
      const question = q.question || {};
      const rawType = question.question_type || question.type || q.type || q.question_type || "short_text";
      const cleanedType = rawType.toLowerCase().trim();
      return cleanedType;
    },

    extract_question_options(q) {
      const question = q.question || {};
      const options = question.choices || q.choices || [];
      return options;
    },

    process_question(q, new_form_data) {
      const title = this.extract_question_title(q);
      const cleanedType = this.extract_question_type(q);
      const options = this.extract_question_options(q);

      Reflect.set(new_form_data, q.id, this.get_initial_value(cleanedType));

      const question_data = {
        junction_id: q.id,
        title: title,
        type: cleanedType,
        options: options,
        required: q.required,
        multiple: q.multiple || false
      };

      return question_data;
    },

async on_project_change() {
  if (!this.selected_project) return;

  const response = await axios.get(GET_ENQUIRY_FORM_QUESTIONS, {
    params: { project_id: this.selected_project }
  });

  const form_result = response.data.data;

  if (!form_result || !form_result.questions) {
    this.show_error("No questions found for this project.");
    return;
  }

  this.enquiry_form_id = form_result.id;

  const new_form_data = {};

  this.enquiry_form_questions = form_result.questions.map(q => {
    const processed_question = this.process_question(q, new_form_data);
    return processed_question;
  });

  this.form_data = new_form_data;
},

get_initial_value(type) {
  let initial_value;

  switch(type) {
    case 'multi_select':
    case 'checkbox':
      initial_value = [];
      break;
    case 'number':
      initial_value = null;
      break;
    case 'file':
      initial_value = null;
      break;
    default:
      initial_value = '';
  }

  return initial_value;
},

    async submit_enquiry() {
      if (!this.enquiry_form_id) {
        this.show_error("Please select a project first.");
        return;
      }

      const responses = this.enquiry_form_questions
        .map(question => {
          const value = this.form_data[question.junction_id];

          if (!value || (Array.isArray(value) && value.length === 0)) return null;

          let formatted_value = value;

          if (Array.isArray(value)) {
            formatted_value = value.join(', ');
          }

          if (value instanceof File) {
            formatted_value = value.name;
          }

          const response_item = {
            enquiry_form_question_id: question.junction_id,
            answer: String(formatted_value)
          };

          return response_item;
        })
        .filter(Boolean);

      if (responses.length === 0) {
        this.show_error("Please answer at least one question.");
        return;
      }

      const payload = {
        enquiry_form_id: parseInt(this.enquiry_form_id, 10),
        responses
      };

      const response = await axios.post(SUBMIT_ENQUIRY_FORM, payload);

      if (response.data.status === 'success') {
        this.show_success("Enquiry submitted successfully! Redirecting to login...");
        this.reset_form();

        // Redirect to login after 2 seconds to allow user to see the success message
        this.$router.push({
          path: "/",
        });
      } else {
        this.show_error(response.data.message || "Submission failed.");
      }
    },

    reset_form() {
      for (const question of this.enquiry_form_questions) {
        const initial_value = this.get_initial_value(question.type);
        Reflect.set(this.form_data, question.junction_id, initial_value);
      }
    },

    create_pdf_url() {
      if (this.privacy_statement) {
        const byte_chars = atob(this.privacy_statement);
        const bytes = Uint8Array.from(byte_chars, c => c.charCodeAt(0));

        this.pdf_url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      }
    },

    handle_file_upload(event, junction_id) {
      const files = event.target.files;

      Reflect.set(
        this.form_data,
        junction_id,
        files.length > 1 ? Array.from(files) : files[0]
      );
    }
  },

  beforeUnmount() {
    if (this.pdf_url) URL.revokeObjectURL(this.pdf_url);
  }
};